import { type AgHeatmapSeriesOptions, _ModuleSupport } from 'ag-charts-community';
import {
    type OptionsDefs,
    arrayOf,
    color,
    colorScaleOptionsDef,
    commonSeriesOptionsDefs,
    constant,
    deprecated,
    required,
    string,
    without,
} from 'ag-charts-core';

const { heatmapSeriesThemeableOptionsDef } = _ModuleSupport;

export const heatmapSeriesOptionsDef: OptionsDefs<AgHeatmapSeriesOptions> = {
    ...without(heatmapSeriesThemeableOptionsDef, ['showInLegend']),
    ...without(commonSeriesOptionsDefs, ['showInLegend']),
    type: required(constant('heatmap')),
    xKey: required(string),
    yKey: required(string),
    xKeyAxis: string,
    yKeyAxis: string,
    colorKey: string,
    xName: string,
    yName: string,
    colorName: string,
    colorRange: deprecated(arrayOf(color), 'Use `colorScale.fills` instead.'),
    colorScale: colorScaleOptionsDef,
};
